<script lang="ts" setup>
import { computed } from 'vue';
import type { CustomerMgmtTypes } from '@ilteducation/customer-mgmt';
import Modal from '../Modal.vue';
import useModal, { modals } from '../../composables/useModal';
import { useLocale } from '../../composables/useLocale';
import { useDeleteUserAssociation } from '../../composables/useDeleteUserAssociation';

const { t } = useLocale();

const props = defineProps<{
  user: CustomerMgmtTypes.GetUserResponse;
}>();

const emits = defineEmits<{
  (event: 'deleted', value: string): void;
}>();

const { close, context } = useModal(modals.DELETE_USER);

const user = computed(() => props.user);
const { isDeleting, deleteUser } = useDeleteUserAssociation(user);

const onConfirm = async () => {
  const isDeleted = await deleteUser(context.value.organizationUids);

  if (isDeleted) {
    close();
    context.value.onDeleted?.();
    emits('deleted', user.value.uid);
    return;
  }

  context.value.onFailure?.();
};

const onCancel = () => {
  const onBack = context.value.onBack;
  close();
  onBack?.();
};
</script>

<template>
  <Modal
    :name="modals.DELETE_USER"
    :title="t('lcp.confirm_user_deletion')"
    :show-close-btn="true"
    :loading="isDeleting"
    :action="onConfirm"
    action-color="error"
    :action-label="t('lcp.delete_user')"
    :cancel-action="onCancel"
    :cancel-action-label="t('lcp.cancel')"
    cancel-action-color="success"
  >
    <p>
      {{ t('lcp.confirm_user_deletion_message') }}
    </p>
  </Modal>
</template>

<style scoped lang="scss"></style>
